<template>
  <div class="parent_div">
    <dd-header />
    <div class="wrapper">
      <div class="main_content">
        <dd-menu ref="menuRef"/>
        <div>
          <dd-sitemap
            :pageKey="pageKey"
            :pageList="pageList"
            :mapStyle="'topic_path'"
          />
          <section class="select_category">
            <h2>施工事例</h2>
            <dd-category-list />
          </section>
          <section>
            <h2>写真をクリックして施工事例をご覧ください！</h2>
          </section>
          <section>
            <h2>お客様に選ばれる3つの理由</h2>
            <dd-reason />
          </section>
        </div>
      </div>
    </div>
    <dd-footer />
    <!-- ローディングモーダル -->
    <dd-loading-modal ref="loadingModalRef" />
  </div>
</template>
<script>
import DcHeader from '../components/common/DcHeader'
import DcFooter from '../components/common/DcFooter'
import DDLeftMenu from '../components/top/DcLeftMenu'
import DcSiteMap from '../components/common/DcSiteMap'
import DDReason from '../components/top/DcSelectReason'
import DcCategoryList from '../components/top/DcCategoryList'
import LoadingModal from '../../components/common/LoadingModal'

export default {
  components: {
    'dd-header': DcHeader,
    'dd-footer': DcFooter,
    'dd-menu': DDLeftMenu,
    'dd-loading-modal': LoadingModal,
    'dd-reason': DDReason,
    'dd-category-list': DcCategoryList,
    'dd-sitemap': DcSiteMap
  },
  data () {
    return {
      pageKey: 'dcConstructModel',
      pageList: [
        {id: 'top', key: 'dcTop', title: 'トップページ', route: 'DcTop'},
        {id: 'constructModel', key: 'dcConstructModel', title: '施工事例', route: 'DcConstructModel'}
      ]
    }
  },
  computed: {
  },
  methods: {
    // getCategoryList: function () {
    //   axios.get(DC_URL.TOP + '/category')
    //     .then(response => {
    //       if (response.data.errorMessage) {
    //         this.handleErrorMessage(response)
    //       }
    //       this.categoryList = response.data.data
    //     }).catch(error => {
    //       Api.handleError(error)
    //     }).finally(() => {
    //       this.$refs.loadingModalRef.showModal(false)
    //     })
    // },
    // getImage: function (image) {
    //   return App.getMmstyleResource(image)
    // },
    // categoryImgBlack: function (imgName) {
    //   let index = String(imgName).indexOf('.')
    //   let file = String(imgName).substring(0, index)
    //   let exp = String(imgName).substring(index, imgName.length)
    //   return this.getImage('category/' + file + '_black' + exp)
    // },
    // categoryImgWhite: function (imgName) {
    //   if (!imgName) return undefined
    //   let index = String(imgName).indexOf('.')
    //   let file = String(imgName).substring(0, index)
    //   let exp = String(imgName).substring(index, imgName.length)
    //   return this.getImage('category/' + file + '_white' + exp)
    // },
    // selectCategory: function (category) {
    //   this.selCategoryNo = category.id
    // }
  },
  mounted: function () {
    // this.getCategoryList()
    // this.selCategoryNo = 1
  },
  created: function () {
  }
}
</script>
<style src="../css/dctop4.scss" lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/main/js/payment/pages/DcConstructModel.vue